import React from "react";
import { useTable } from "react-table";
import { dollarUS } from "../../utilities/formatters";
import Flag from "react-world-flags";
// import "./ResultsTable.scss";

const InstrumentTradeTable = ({ data }) => {
  // const data = [
  //   {
  //     instrument: "EUR / JPY",
  //     trades: "01",
  //     result: "-$0.16",
  //     longTrades: { trades: "01", result: "-$0.16" },
  //     shortTrades: { trades: "00", result: "$0.00" },
  //   },
  //   {
  //     instrument: "EUR / USD",
  //     trades: "10",
  //     result: "-$201.23",
  //     longTrades: { trades: "10", result: "-$65.92" },
  //     shortTrades: { trades: "01", result: "-$135.31" },
  //   },
  //   {
  //     instrument: "GBP / AUD",
  //     trades: "02",
  //     result: "-$75.66",
  //     longTrades: { trades: "02", result: "-$75.66" },
  //     shortTrades: { trades: "00", result: "$0.00" },
  //   },
  //   {
  //     instrument: "GBP / CAD",
  //     trades: "02",
  //     result: "$171.41",
  //     longTrades: { trades: "02", result: "$171.41" },
  //     shortTrades: { trades: "00", result: "$0.00" },
  //   },
  // ];

  const newData = data && data?.result_by_instruments?.map((item) => item);

  const countryName =
    newData && newData?.map((item) => String(item[0]).replace(".pro", ""));

  const firstCode = countryName && countryName?.map((item) => item.slice(0, 2));
  const secondCode =
    countryName && countryName?.map((item) => item.slice(3, 5));
  const firstCountry =
    countryName && countryName?.map((item) => item.slice(0, 3));
  const secondCountry =
    countryName && countryName?.map((item) => item.slice(3, 6));
  console.log("newData", secondCountry);

  return (
    <>
      <div className="instrumentTradeTable_main">
        <div className="instrumentTradeTable_left">
          <div className="instrumentTradeTable_left_header">
            <button>Instruments</button>
          </div>
          <div className="instrument_box">
            {newData &&
              newData?.map((item, index) => (
                <div key={index} className="instrument_country_flags">
                  <div className="country_flag">
                    <div>
                      <Flag code={firstCode[index]} />
                    </div>

                    <p>{firstCountry[index]}</p>
                  </div>
                  <p>{"/"}</p>
                  <div className="country_flag">
                    <div>
                      <Flag code={secondCode[index]} />
                    </div>

                    <p>{secondCountry[index]}</p>
                  </div>
                  {/* <button>{item[0]}</button> */}
                </div>
              ))}
          </div>
        </div>
        <div className="instrumentTradeTable_right">
          <div className="instrumentTradeTable_right_header">
            <div className="instrumentTradeTable_right_header_inner">
              <p>No. of trades</p>
              <p>Results</p>
            </div>
            <div className="instrumentTradeTable_right_header_inner">
              <p>No. of trades</p>
              <p>Results</p>
            </div>
            <div className="instrumentTradeTable_right_header_inner">
              <p>No. of trades</p>
              <p>Results</p>
            </div>
          </div>
          <div className="instrumentTradeTable_right_lower">
            <div className="trades_details">
              {newData &&
                newData?.map((item) => (
                  <>
                    <div className="instrumentTradeTable_right_lower_inner first_box">
                      <p>{item[1]?.number_of_trade}</p>
                      <p
                        className={`${
                          item[1]?.results > 0
                            ? "profit"
                            : item[1]?.results < 0
                            ? "loss"
                            : ""
                        }`}
                      >
                        {dollarUS(item[1]?.results) || "--"}
                      </p>
                    </div>
                  </>
                ))}
            </div>

            <div className="trades_details">
              <h3>Long Trades</h3>
              {newData &&
                newData?.map((item) => (
                  <>
                    <div className="instrumentTradeTable_right_lower_inner">
                      <p>{item[1]?.long_trade}</p>
                      <p
                        className={`${
                          item[1]?.long_result > 0
                            ? "profit"
                            : item[1]?.long_result < 0
                            ? "loss"
                            : ""
                        }`}
                      >
                        {dollarUS(item[1]?.long_result) || "--"}
                      </p>
                    </div>
                  </>
                ))}
            </div>

            <div className="trades_details">
              <h3>Short Trades</h3>
              {newData &&
                newData?.map((item) => (
                  <>
                    <div className="instrumentTradeTable_right_lower_inner">
                      <p>{item[1]?.short_trade}</p>
                      <p
                        className={`${
                          item[1]?.short_result > 0
                            ? "profit"
                            : item[1]?.short_result < 0
                            ? "loss"
                            : ""
                        }`}
                      >
                        {dollarUS(item[1]?.short_result) || "--"}
                      </p>
                    </div>
                  </>
                ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InstrumentTradeTable;
